import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchRoomTable, fetchRoom, fetchRoomById, addRoom, updateRoom, removeRoom } from "../../api/roomApi";

// Async thunks for room operations

export const getRooms = createAsyncThunk(
  "room/getRooms",
  async ({ page, limit }: { page: number; limit: number }, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchRoomTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getRoomById = createAsyncThunk(
  "room/getRoomById",
  async (id: string, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchRoomById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createRoom = createAsyncThunk(
  "room/createRoom",
  async (newRoom: any, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addRoom(newRoom);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editRoom = createAsyncThunk(
  "room/editRoom",
  async ({ id, updatedRoom }: { id: string; updatedRoom: any }, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateRoom(id, updatedRoom);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteRoom = createAsyncThunk(
  "room/deleteRoom",
  async (id: string, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeRoom(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Room Slice

const roomSlice = createSlice({
  name: "room",
  initialState: {
    rooms: [] as any[],
    
    room: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all rooms
      .addCase(getRooms.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.rooms = action.payload;
      })
      .addCase(getRooms.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Get room by ID
      .addCase(getRoomById.fulfilled, (state, action: PayloadAction<any>) => {
        console.log(action.payload.data,'action.payload');
        
        state.status = true;
        state.room = action.payload;
      })
      .addCase(getRoomById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Create room
      .addCase(createRoom.fulfilled, (state, action: PayloadAction<any>) => {
        if(Array.isArray(action.payload)){

        state.rooms.push(action.payload);
        state.status = true;
        state.msg = "Room created successfully.";
        }
        else{
          console.log('room not aaray');

        }
      })
      
      // Edit room
      .addCase(editRoom.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if(Array.isArray(state.rooms)){

        const index = state.rooms.findIndex((room) => room.id === id);
        if (index !== -1) {
          state.rooms[index] = data;
        }
        state.status = true;
        state.msg = "Room updated successfully.";
      }
        else{
          console.log('room not aaray');

        }
      })
      
      // Delete room
      .addCase(deleteRoom.fulfilled, (state, action: PayloadAction<string>) => {
        if(Array.isArray(state.rooms)){

        state.rooms = state.rooms.filter((room) => room.id !== action.payload);
        state.status = true;
        state.msg = "Room deleted successfully.";
      }
      else{
        console.log('room not aaray');

      }
      });
  },
});

export const { resetStatus } = roomSlice.actions;
export default roomSlice.reducer;
